module.exports = __webpack_public_path__ + "static/media/BLIPBLA-BACKGROUND-2.d7bd8a56.jpg";